module.exports = __webpack_public_path__ + "img/td.76d921fa.png";